export default "__VITE_ASSET__CcySWFXx__"